import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sliderBarTime" }
const _hoisted_2 = { class: "runTime" }
const _hoisted_3 = { class: "runTime" }

import { ref,onMounted,watch} from "vue";
    // 时间处理方法
import { timeInfo, timeInfominute, timedata } from '@/components/public-method/time-method';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'sliderOther',
  props: {
        num: Number,
        max:Number,
    },
  emits: ['updataNum'],
  setup(__props, { emit: __emit }) {

    const props = __props
    
    const bar = ref<HTMLElement>();
    const Pos = ref("left: 0;");
    const leftNum=ref(0)
    watch(() => props.num, (n, o) =>{
        // console.log('watch'+n)
        // console.log(props.num)
        // console.log(props.max)
        // console.log(props.max)
        if(n>props.max){
            // moveNum()
            return
        }else if(n<0){
            // moveNum()
            return
        }
        // let w = bar.value.clientWidth;
        // leftNum.value=(n/props.max)*w
        // Pos.value = `left: ${leftNum.value}px;`;

        // let w = bar.value.clientWidth;
        // moveNum()
        leftNum.value=(n/props.max)*100
        Pos.value = `left: ${leftNum.value}%;`;
        // console.log('进度'+ leftNum.value)
    })
    // 初始化状态
     onMounted(()=>{
        let w = bar.value.clientWidth;
        leftNum.value=(props.num/props.max)*100
        Pos.value = `left: ${(props.num/props.max)*w}px;`;
    })
    const emit = __emit
    const moveNum=()=>{
        let w = bar.value.clientWidth;
        // console.log(Math.ceil(leftNum.value/100*props.max))
        emit('updataNum',Math.ceil(leftNum.value/100*props.max))
    }
    // 点击后添加事件
    const mousedown = () => {
        window.addEventListener("mousemove", handleChange);
        window.addEventListener("mouseup", mouseup);
        // window.addEventListener("mouseleave", mouseup);
        
    };
    // 移动滑块
    const handleChange = (e: any) => {
        if (!bar.value) return;
        // 获取滑块的宽度（可移动区域）
        let w = bar.value.clientWidth;
        // 获取鼠标的位置
        let x = e.pageX - bar.value.getBoundingClientRect().left;
        // 判断是否超出范围
        // x = x < w && x > 0 ? x : x > w ? w : 0;
        if(x > w){
            x=w
        }else if(x<0){
            x=0
        }
        leftNum.value=Math.ceil((x/w)*100)
        Pos.value = `left: ${x}px;`;
        moveNum()
        // leftNum.value=x
        // Pos.value = `left: ${leftNum.value}px;`;
        // moveNum()
    };
    // 鼠标放开后移除事件
    const mouseup = () => {
        // emit('updataNum',Math.ceil(leftNum.value))
        emit('updataNum',Math.ceil(leftNum.value/100*props.max))
        document.ondragstart = function(ev) {
            ev.preventDefault();
        };
        document.ondragend = function(ev) {
            ev.preventDefault();
        };
        window.removeEventListener("mousemove", handleChange);
        window.removeEventListener("mouseup", mouseup);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bar",
    ref_key: "bar",
    ref: bar
  }, [
    _createElementVNode("div", {
      class: "sliderBar",
      style: _normalizeStyle({'width':leftNum.value+'%'})
    }, null, 4),
    _createElementVNode("div", {
      class: "slider",
      style: _normalizeStyle(Pos.value),
      onMousedown: mousedown
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "timeBlock" }, [
        _createElementVNode("div", { class: "square" }),
        _createElementVNode("div", { class: "arrow" })
      ], -1)
    ]), 36),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(timeInfominute)(props.num )), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(timeInfominute)(props.max -props.num)), 1)
    ])
  ], 512))
}
}

})